"use client";
import React, { FC, useState } from "react";
import classNames from "classnames";
import { useTranslations } from "next-intl";

import { Checkbox, ShowWhen } from "@/components/common";
import { Info2Icon, ShippingArrowUp } from "@/components/assets/icons";
import { useAllShipmentServicesRequest } from "@/api/useShipmentServicesRequest";
import { additionalServicesIcons } from "@/utils/additional";
import { IShipmentService } from "@/types/apiResponse.types";
import { TAdditionalServicesProps } from "../types";
import { useTheme } from "@/context/Theme.context";
import { Theme } from "@/enums";
import { formatNumber } from "@/utils/formatNumber";

const AdditionalServices: FC<TAdditionalServicesProps> = ({
  additionalServices,
  handleSelectService,
  isSendParcel,
}) => {
  const [isOpened, setisOpened] = useState(true);

  const theme = useTheme();

  const t = useTranslations();

  const { data } = useAllShipmentServicesRequest(true);

  const servicesList = (data?.data?.data || []) as IShipmentService[];

  const handleToggle = () => {
    setisOpened((prev) => !prev);
  };

  return (
    <>
      <ShowWhen condition={!isSendParcel}>
        <div className="mt-6 rounded-[30px] bg-[#f1f6f7] p-5">
          <div className="flex w-full items-center justify-between">
            <h2 className="text-sm font-medium uppercase text-[#ADADAD]">
              {t("additional_services")}
            </h2>

            <span
              className="flex h-[20px] w-[20px] cursor-pointer items-center justify-center"
              onClick={handleToggle}
            >
              <ShippingArrowUp
                className={classNames("transform", {
                  "rotate-180": !isOpened,
                })}
              />
            </span>
          </div>
          <ShowWhen condition={isOpened}>
            <div className="mt-3 cursor-pointer p-4">
              <ul className="grid w-full md:gap-4 lg:grid-cols-2 2xl:grid-cols-3 2xl:gap-8">
                {servicesList &&
                  servicesList?.map((item, index) => {
                    const Icon =
                      additionalServicesIcons.find(
                        (icon) => icon.serviceId === item.serviceId,
                      )?.icon || null;

                    const servicePrice =
                      theme === Theme.UZ
                        ? item.servicePriceNational
                        : item.servicePrice;

                    let isDisabled = false;

                    if (theme === Theme.UK) {
                      if (
                        item.serviceId === 204 &&
                        additionalServices.includes(113)
                      ) {
                        isDisabled = true;
                      }

                      if (
                        item.serviceId === 113 &&
                        additionalServices.includes(204)
                      ) {
                        isDisabled = true;
                      }

                      if (
                        item.serviceId === 2 &&
                        additionalServices.includes(204)
                      ) {
                        isDisabled = true;
                      }

                      if (
                        item.serviceId === 204 &&
                        additionalServices.includes(2)
                      ) {
                        isDisabled = true;
                      }
                    }

                    return (
                      <li
                        key={index}
                        className="relative flex w-full items-center justify-between"
                      >
                        <div
                          className="flex w-2/3 gap-2"
                          onClick={() => {
                            if (isDisabled) {
                              return;
                            }
                            handleSelectService(item.serviceId);
                          }}
                        >
                          <div className="flex h-[2.37rem] w-[2.37rem] items-center justify-center rounded-lg bg-white p-1">
                            {Icon && <Icon className="primary-color" />}
                          </div>
                          <div>
                            <div className="flex flex-row items-center gap-2">
                              <p
                                className={classNames(
                                  "text-xs font-semibold text-black",
                                )}
                              >
                                {item.serviceName}
                              </p>
                              {item.serviceId === 211 && (
                                <a
                                  href="https://lex.uz/ru/docs/7357270#"
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <Info2Icon />
                                </a>
                              )}
                            </div>

                            <p className="text-sm font-normal text-[#666666]">
                              {theme === Theme.GEORGIA && item.serviceId === 113
                                ? `$ ${item.baseCostForServiceInsuranceInUsd || 0}`
                                : (theme === Theme.UK || theme === Theme.UZ) &&
                                    item.serviceId === 113
                                  ? `${servicePrice || 0}%`
                                  : `${theme === Theme.UZ ? t("uzs") : "$"} ${formatNumber(servicePrice || 0)}`}
                            </p>
                          </div>
                        </div>

                        <Checkbox
                          name="checkbox"
                          checked={additionalServices.includes(item.serviceId)}
                          width="w-fit w-1/3"
                          onChange={(e) => handleSelectService(item.serviceId)}
                          disabled={isDisabled}
                        />
                      </li>
                    );
                  })}
              </ul>
            </div>
          </ShowWhen>
        </div>
      </ShowWhen>
    </>
  );
};

export { AdditionalServices };
